import React, { useState } from "react";
import "./mainpage.css";
import Sidebar from "../../components/sidebar/SideBar";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";

const MainPage = ({ children, title = "Top Header" }) => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="container">

      {/* Sidebar */}
      <Sidebar collapsed={collapsed} />

      {/* Right Side */}
      <div className={`right-div ${collapsed ? "collapsed" : ""}`}>

        {/* Top Header */}
        <div className="top-header">
          <div
            className="menu-trigger"
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </div>

         <h3 style={{ color: "black", fontSize: "17px" }}>
  &nbsp;&nbsp;{title}
</h3>

        </div>

        {/* Dynamic Content using Props */}
        <div className="right-content">
          {children}
        </div>

      </div>
    </div>
  );
};

export default MainPage;
